export default {
    name: 'Index',
    data() {
        return {
            code:'', 
            isShowForeCast:false,
            foreCastInfo:[],
            loading:false,
            loadingMsg:null,
            rankFirst:[],
            rankAll:[],
            mapinfo:{code:'',mapcode:'',mainConvertUs:0,mapConvertUs:0},
            rankgFallAll:[],
            favoriteList:[],
            isShowMapCode:false,
            isShowReports:false,
            mapinfolist:[]
        };
    },
    methods: {
        // 用于初始化一些数据
        init() {
            this.loadRankingOfUsFirst();//下载知名美股涨幅股票
            this.loadRankingOfUsAll();//下载全部美股涨幅
            this.loadRankingFallOfUs();//下载美股跌幅
            this.loadFavoriteList();//我的收藏
        // this.loadAllForecastUsStock();//触发定时下载全部涨跌幅股票的雅虎预测测报
         // this.loadZygcUsStock();//触发定时下载全部涨跌幅股票的雅虎预测测报
        },
        // 用于更新一些数据
        searchByCode() { 

            this.$router.push('/FinanceInfo?code='+this.code.toUpperCase())

        },
        viewByCode(el){
            this.$router.push('/FinanceInfo?code='+el.toUpperCase())
        },
        viewDayInfo(el){
            this.$router.push('/EveryDayInfo?code='+el.code.toUpperCase())
        },
        async  searchForecast() { 

            if(this.code){
                this.isShowForeCast=true
                this.foreCastInfo={_id:"数据载入中",content:'数据正在载入请稍后'}
                this.showLoading('数据加载中') 
                const res = await this.$http.post('DownYh/GetUsFinanceCastContentByCode', {code:this.code.toUpperCase()});
                if(res.Status){
                   this.foreCastInfo=res.Result;
                   this.close();
                } 

            }else{
                
                this.$error('请输入股票代码'); 
            }

           

        }, 
      async  viewForecast(el){
            this.isShowForeCast=true
            this.foreCastInfo={_id:"数据载入中",content:'数据正在载入请稍后'}
            this.showLoading('数据加载中') 
            const res = await this.$http.post('DownYh/GetUsFinanceCastContentByCode', {code:el.code.toUpperCase()});
            if(res.Status){
               this.foreCastInfo=res.Result;
               this.close();
            }
        },
        showLoading(txt) {
            this.close();
            this.loadingMsg = this.$loading({
                lock: true,
                text: txt+'……',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
        },
        close() { 
            if(this.loadingMsg)
            this.loadingMsg.close();
        },
        async loadFavoriteList(){

            this.loading = true;
            const res = await this.$http.post('StockAlignMap/SearchStockFavoriteAndStockAlignMap', {});//
            if(res.Status){ 
                this.favoriteList=res.Result; 
            }
            this.loading = false;
    

        },
        async RemoveStockFavorite(el){

            const res = await this.$http.post('StockFavorite/RemoveStockFavorite', {code:el.code});//
            if(res.Status){ 
                this.loadFavoriteList();//我的收藏
                this.$success('移除成功');    

                 
            }else{
                this.$error('移除失败：'+res.Msg); 

            }

        },
        searchReports(){ 
            this.$router.push('/Earnings')

        },
        searchGrowth(){
            this.$router.push('/Growth')
        },
        async setAlignCode(item){
            this.isShowMapCode=true
            this.mapinfo.code=item
            const res = await this.$http.post('StockAlignMap/SearchStockAlignMap',this.mapinfo);            
            if(res.Status)
            {
                this.mapinfolist=res.Result
            }
 

        },
        async savemapcode(){
          
            const res = await this.$http.post('StockAlignMap/SaveStockAlignMap',this.mapinfo);//id=1 知名美股涨幅
            if(res.Status){
                this.$success('保存成功'); 
                this.isShowMapCode=false
                this.loadFavoriteList()

            }else{
                this.$error('保存失败');  
            }
        },
        async SaveMainConvertUs(item){
            
            const res = await this.$http.post('StockAlignMap/SaveMainConvertUs',{code:item.code,mainConvertUs:item.mainConvertUs});
            if(res.Status){
                this.$success('保存成功'); 

            }else{
                this.$error('保存失败');  
            }

        },
        async SaveMapConvertUs(item){
            
            const res = await this.$http.post('StockAlignMap/SaveMapConvertUs',{code:item.mapcode,mapConvertUs:item.mapConvertUs});
            if(res.Status){
                this.$success('保存成功'); 

            }else{
                this.$error('保存失败');  
            }

        },
       async loadRankingOfUsFirst(){
           
        this.loading = true;
            const res = await this.$http.post('DownEast/SearchRiseFallOfUs', {id:1});//id=1 知名美股涨幅
            if(res.Status){ 
                this.rankFirst=res.Result; 
            }
            this.loading = false;
    
           },  

           async loadRankingOfUsAll(){
           
            this.loading = true;
                const res = await this.$http.post('DownEast/SearchRiseFallOfUs', {id:0});//id=0 全部美股涨幅
                if(res.Status){
        
                    this.rankAll=res.Result; 
        
                }
                
                this.loading = false;
            },
       async loadRankingFallOfUs(){
           
        this.loading = true;
            const res = await this.$http.post('DownEast/SearchFallOfUs', {id:0});//id=0 美股跌幅排行
            if(res.Status){
    
                this.rankgFallAll=res.Result; 
    
            }
            
            this.loading = false;
        },


        async loadAllForecastUsStock(){
          const res=   await this.$http.post('DownYh/DownAllOfUsForecast', {code:'123321'});// 美股涨跌幅排行榜的股票雅虎预测           
            console.warn(res)
        },
        async loadZygcUsStock(){
            const res=   await this.$http.post('DownEastTime/DownZhuyingGouCheng', {code:'123321'});// 美股涨跌幅排行榜的股票雅虎预测           
              console.warn(res)
          }



    },
    // 计算属性
    computed: {
        identity() {
            let identity = '管理员';
            return identity;
        }
    },
    // 包含 Vue 实例可用过滤器的哈希表。
    filters: {},
    // 在实例创建完成后被立即调用
    created() { },
    // 在挂载开始之前被调用：相关的 render 函数首次被调用。
    beforeMount() {
         
    },
    // el 被新创建的 vm.el 替换，并挂载到实例上去之后调用该钩子。
    mounted() {
        this.$nextTick(() => { 
            this.init();
        });
    },
    // 数据更新时调用，发生在虚拟 DOM 打补丁之前。
    beforeUpdate() { },
    // keep-alive 组件激活时调用。
    activated() { },
    // keep-alive 组件停用时调用。
    deactivated() { },
    // 实例销毁之前调用。在这一步，实例仍然完全可用。
    beforeDestroy() { },
    //Vue 实例销毁后调用。
    destroyed() { },
    // 当捕获一个来自子孙组件的错误时被调用。
    errorCaptured() { },
    // 包含 Vue 实例可用指令的哈希表。
    directives: {},
    // 一个对象，键是需要观察的表达式，值是对应回调函数。
    watch: {},
    // 组件列表
    components: {},
};